@for (title of data; track title.icons) {
    <finder-section
        class="accordion"
        (click)="clicked($event, EVENTS.CATEGORY, title.id)"
        (keydown.enter)="clicked($event, EVENTS.CATEGORY, title.id)"
        [sync]="true"
        [id]="title.id"
        [icons]="title.icons"
        [labels]="title.labels">
        @for (listItem of title.listItems; track listItem.id) {
            <div
                role="button"
                tabindex="-1"
                (click)="clicked($event, EVENTS.LIST_ITEM, listItem.id)"
                class="location"
                (keydown.enter)="clicked($event, EVENTS.LIST_ITEM, listItem.id)"
                [id]="listItem.id">
                    @if (listItem.icon) {
                        <finder-font-icon class="list-icon" size="l" [name]="listItem.icon"></finder-font-icon>
                    }
                    <span>{{listItem.name}}</span>
                    <finder-font-icon class="caret" size="s" svg="true" name="next-2"></finder-font-icon>
            </div>
        }
    </finder-section>
    <!-- Added below for SEO reasons. These are hidden until clicked on the page -->
    @for (listItem of title.listItems; track listItem.id) {
        <span aria-hidden="true" class="seo-location">{{listItem.name}}</span>
    }
}

